import {isIntersectionObserverEnabled} from "../utils/helpers";

const singleJob = document.querySelector('.single-job');
const stickyBar = document.querySelector('.sticky-bar');
const form = document.querySelector('.job-section--form');
const classList = {
    isSticky: 'is-sticky'
};

const isSingleJob = singleJob !== null

const handleStickyBar = () => {
    if (!isIntersectionObserverEnabled() || !stickyBar || !form) {
        return
    }

    const handleIntersection = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                stickyBar.classList.remove(classList.isSticky)
            } else {
                stickyBar.classList.add(classList.isSticky)
            }
        })
    }

    const observer = new IntersectionObserver(handleIntersection, {
        root: null,
        threshold: 0.25,
    });

    observer.observe(form)
}

const init = () => {
    if (!isSingleJob) {
        return
    }

    handleStickyBar()
}

export default () => {
    init()
}